import { useState, useEffect } from 'react'; 
import Box from '@mui/material/Box';
import ContentColumn from '../components/contentColumn.js'; 
import Divider from '@mui/material/Divider'; 
import GenerateColumn from '../components/generateColumn.js';
import SearchHeader from '../components/filter/searchHeader.js';
import SelectionColumn from '../components/selectionColumn.js'; 
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import Tabs from '@mui/material/Tabs'; 
import { v4 as uuid } from "uuid";  
 
let today = new Date(); 
today.setHours(23, 59, 59, 59);  
let last_7_days = new Date();
last_7_days.setDate(today.getDate() - 7); 
last_7_days.setHours(0, 0, 0, 0); 

const tabs = ["overview", "chat", "social"]
  
const DashboardPage = (props) => { 
  const [tab, setTab] = useState('overview'); 
  const [addedTag, setAddedTag] = useState(); // This is to link to the added tags from word cloud
  const [selected, setSelected] = useState([]); 
  const [current, setCurrent] = useState([]); 
  const [generate, setGenerate] = useState(false);  
  const [filter, setFilter] = useState(
    [
      {
        match_all: {}
      },
      {
        range: {
          messageDatetime: {
            gte: Date.parse(last_7_days),
            lte: Date.parse(today)
          }
        }
      }
    ]
  )  
  const [selectedGroups, setSelectedGroups] = useState([]);  
  const [date, setDate] = useState();
  const [viewerInfo, setViewerInfo] = useState([]); 
  const [deselect, setDeselect] = useState({
    deselect: false,
    key: uuid().slice(0, 8)
  })
  const [highlighterList, setHighlighterList] = useState([]);
  
  /** Callback logic for filter values (search header). This fires when "Search" button is clicked. **/ 
  function handleChangeFilter(value) {   
    setFilter(value);     
    setSelected([]); 
    setSelectedGroups([]);
  }
  
  useEffect(() => {  
    setCurrent([]); // Reset generated checked boxes when "Search" button is clicked
    // console.log(filter)
  }, [filter])
  
  // useEffect(() => {
  //   console.log(viewerInfo)
  //   if (viewerInfo.viewer) {
  //     setHideFeedback(true);
  //   } else {
  //     setHideFeedback(false);
  //   }
  // }, [viewerInfo])
 
  /** Changing of tabs **/ //  
  function handleChange(event, tab) {
    setTab(tab);
    setSelected([]); 
    setSelectedGroups([]);
    setCurrent([]);
    setViewerInfo({viewer: false, general: false, pin_list: false}); 
  };  
  
  /** Callback function for word cloud/tables/application chip labels **/
  function handleAddFilterTag(value) {     
    setAddedTag(value);   
  }
  
  /** Callback function for new selection **/  
  function handleAddCheckedList(value) { 
    const temp = [...value];
    setSelected(temp)   // const temp = [...value.selected]; 
  }
  
  /** Callback function to handle selected groups from GenerateColumn **/
  function handleUpdateRequest(value) { 
    // Reset 
    setViewerInfo({viewer: false, general: false, pin_list: false});
    setCurrent(value); 
    let selected_groups = value.filter(item => item !== 0);  
    setSelectedGroups(selected_groups);  
  } 
  
  /** Check to display generateColumn or contentColumn **/
  useEffect(() => {  
    var filtered_curr = current.filter(item => item !== 0);
    var filtered_sel = selected.filter(item => item !== 0);
    var curr = filtered_curr.sort((a, b) => a.commsName.localeCompare(b.commsName));
    var sel = filtered_sel.sort((a, b) => a.commsName.localeCompare(b.commsName));   
    setGenerate(JSON.stringify(curr) !== JSON.stringify(sel))
  }, [current, selected])
  
  /** Callback function for date change from activitiesTrend and multimediaPropagationTrend **/
  function handleChangeDate(value) {  
    setDate(value);   
  }
  
  /** TODO: Callback from selectionColumn.js to navigate to general chat log **/
  function handleViewerInfo(value) { 
    if (value.viewer && value.general) { 
      props.telemetry({
        application: value.application ? value.application : "", 
        application_server: "", 
        comms_guid: value.comms_guid ? value.comms_guid : "", 
        es_record_id: "", 
        event: "content viewer", 
        sub_event: "latest info" 
      });
    }  
    setViewerInfo(value);
  }
  
  /** Callback from generateDisplay.js **/
  const handleClickDeselectAll = (value) => {  
    setDeselect({
      deselect: value.deselect,
      key: value.key
    })
  }
  
  const handleHighlighterList = (value) => { 
    setHighlighterList(value);
  }
      
  return (
    <div sx={{height: '100%'}}> 
      <SearchHeader highlightCallback={handleHighlighterList} telemetry={props.telemetry} added={addedTag} callback={handleChangeFilter} date={date} viewer={handleViewerInfo} user={props.user}/> 
      <Divider variant="middle" /> 
      <Box sx={{ marginLeft: '1rem' }}>
        <TabContext value={tab}>
          <Tabs
            value={tab}
            onChange={handleChange} 
            textColor="inherit"
            indicatorColor="inherit"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#FFB100", 
              }
            }} 
          >
            <Tab sx={{ "&.Mui-selected": { color: "#FFB100" }}} value="overview" label="Overview" />
            <Tab sx={{ "&.Mui-selected": { color: "#FFB100" }}} value="chat" label="Chat" />
            <Tab sx={{ "&.Mui-selected": { color: "#FFB100" }}} value="social" label="Social Media" /> 
          </Tabs>
          {tabs.map((value) => { 
              return (
                <TabPanel sx={{"&.MuiTabPanel-root": { padding: "0 1rem 1rem 0" }}} value={value}> 
                  <div sx={{ width: '100%' }}> 
                    <Box bgcolor="#F6F6F6" sx={{ display: 'flex', height: '100%', paddingLeft: '1rem' }}>
                      <SelectionColumn telemetry={props.telemetry} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'start', marginTop: '1rem' }} deselect={deselect} filters={filter} filterCallback={handleAddFilterTag} callback={handleAddCheckedList} viewer={handleViewerInfo} tab={value} />   
                      <Box sx={{ flexGrow: 1, width: '60vw' }}>
                        {generate ? <GenerateColumn telemetry={props.telemetry} selected={selected} callback={handleUpdateRequest} deselect={handleClickDeselectAll}/> : 
                        <ContentColumn highlight={highlighterList} telemetry={props.telemetry} user={props.user} filterCallback={handleAddFilterTag} dateCallback={handleChangeDate} filters={filter} selected={selectedGroups} tab={value} viewerInfo={viewerInfo}/> }
                      </Box>
                    </Box> 
                  </div> 
              </TabPanel> 
              )
          })} 
        </TabContext>  
      </Box>
    </div>
    );
};

export default DashboardPage;

// display: hideFeedback ? "none" : ""     
// <FormControl>
//   <FormLabel sx={{ fontSize: "16px", color:"grey !important"}}><i>(1 - Least Satisfied, 5 - Most Satisfied)</i></FormLabel>
//   <RadioGroup row onClick={(event) => setRating(event.target.value)}>
//     <FormControlLabel value={1} control={<Radio />} label="1" labelPlacement="bottom" size="small"/>
//     <FormControlLabel value={2} control={<Radio />} label="2" labelPlacement="bottom" size="small"/>
//     <FormControlLabel value={3} control={<Radio />} label="3" labelPlacement="bottom" size="small"/> 
//     <FormControlLabel value={4} control={<Radio />} label="4" labelPlacement="bottom" size="small"/> 
//     <FormControlLabel value={5} control={<Radio />} label="5" labelPlacement="bottom" size="small"/> 
//   </RadioGroup>
// </FormControl>
      //   <Tooltip 
      //     title="Rate us!" 
      //     slotProps={{
      //       popper: {
      //         modifiers: [
      //           {
      //             name: 'offset',
      //             options: {
      //               offset: [0, -8],
      //             },
      //           },
      //         ],
      //       },
      //     }}
      //   >
      //     <Fab onClick={handleClickOpenFeedback} style={{ color: "white", backgroundColor: "#ffb100", margin: 0, top: 'auto', right: 30, bottom: 30, left: 'auto', position: "fixed"}}>
      //       <RateReviewIcon />
      //     </Fab>
      //   </Tooltip> 
      //   <Dialog
      //     open={open}
      //     onClose={handleCloseFeedback}   
      //     sx={{
      //       "& .MuiDialog-container": {
      //         "& .MuiPaper-root": {
      //           width: "100%",
      //           maxWidth: "630px",  // Set your width here
      //         },
      //       },
      //     }}        
      //   > 
      //   <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center", paddingTop: "30px" }}>
      //     <img src={logo} width="70" />
      //   </Box>
      //   <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
      //     <DialogTitle><h3>Your feedback is important to us.</h3></DialogTitle>
      //   </Box>
      //   <DialogContent> 
      //     <DialogContentText sx={{ fontSize: "18px" }}>
      //       How satisfied are you with the features of Hunnycloud?
      //     </DialogContentText>  
      //     <Rating
      //       name="simple-controlled" 
      //       value={feedback.rating}
      //       onChange={(event, newValue) => { 
      //         if (newValue === null) { 
      //           setFeedback(prev => ({...prev, rating: 0}));  
      //         } else { 
      //           setFeedback(prev => ({...prev, rating: newValue}));
      //         }
      //       }} 
      //       sx={{ paddingTop: "5px" }}
      //     />      
      //     <DialogContentText sx={{ paddingTop: "20px", paddingBottom: "10px", fontSize: "18px" }}>
      //       <strong>(Optional)</strong> Why do you feel that way? 
      //     </DialogContentText>
      //     <TextField  
      //       fullWidth
      //       variant="outlined"
      //       multiline
      //       maxRows={5} 
      //       inputProps={{
      //         onBlur: (event) => setFeedback(prev => ({...prev, message: event.target.value}))
      //       }}        
      //     />
      //   </DialogContent> 
      //   <DialogActions>
      //         <Box sx={{display: "flex", flexDirection: "row", gap: "50px", margin: "20px 20px 0px 20px"}}> 
      //           <Button className="dialog-button" onClick={handleCloseFeedback}>
      //               <div className="dialog-button-text">
      //                   Cancel
      //               </div>
      //           </Button>
      //           <Button className="dialog-button" onClick={handleSubmitFeedback}>
      //               <div className="dialog-button-text">
      //                   Submit
      //               </div>
      //           </Button>
      //         </Box>
      //   </DialogActions> 
      //   <Collapse in={feedbackAlert.open}>
      //   <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "center", paddingBottom: "10px" }}>
      //     <Alert  
      //       style={{ width: "70%" }} 
      //       severity={feedbackAlert.status ? "success" : "error"}
      //     >
      //       {feedbackAlert.message}
      //     </Alert>          
      //   </Box> 
      //   </Collapse>
      // </Dialog>    